/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BingAdsService {
    /**
     * Connect a Bing Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Bing Ads account
     * @throws ApiError
     */
    public static postBingConnect(
        workspaceId: string,
        requestBody: {
            name: string;
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bing/connect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Bing Ads account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully disconnected a Bing Ads account
     * @throws ApiError
     */
    public static postBingDisconnect(
        workspaceId: string,
        requestBody: {
            ad_account_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bing/disconnect',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Save a Google token
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully saved Google user token
     * @throws ApiError
     */
    public static postBingToken(
        workspaceId: string,
        requestBody: {
            code: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/bing/token',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List available to connect Bing Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List available to connect Bing Ads accounts
     * @throws ApiError
     */
    public static getBingAvailable(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bing/available',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Bing Ads accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Bing Ads accounts
     * @throws ApiError
     */
    public static getBingConnected(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/bing/connected',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
